<template lang="pug">
#main-footer
  p {{$t('footer.line1')}}
  p {{$t('footer.line2')}}
  p 
    a(:href="`mailto:${$t('footer.jcyl.line3')}`" target="_blank") {{ $t('footer.jcyl.line3') }}
</template>

<script>
export default {
  name: 'Footer'
}
</script>
